/* CGC jewelry + add-on buy box (sections/cgc-jewelry-buybox.liquid). Jewelry lane, 10-15.
   Money + Transcy display handling, gallery, sticky columns and the cart drawer follow cgc-gift-builder.js.
   Line-item properties: every "Engraving field" posts properties[<its property>] verbatim, plus the hidden key=value pairs.
   Extras (10-20, owner "100% fix it all"): Love Card + Glitter Rose Bouquet (assets/cgc-extras.js = X) above the total
     where the template turns them on; picked extras ride in the same add call, every line sharing one _jewelry_bundle_id
     so the cart folds them under the bracelets.
   QA handle: window.CGC_JEWELRY[sectionId] = { S, payload, render, last, extras } */
(function () {
  'use strict';
  var REG = window.CGC_JEWELRY = window.CGC_JEWELRY || {};
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function handle(s) { return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }

  function init(root) {
    if (root.__cgj) return;
    var cfgEl = root.querySelector('script[data-cgj-cfg]'); if (!cfgEl) return;
    var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[cgc-jewelry] bad config', e); return; }
    var P = CFG.product; if (!P || !P.variants || !P.variants.length) return;
    root.__cgj = true;
    var R = function (k) { return root.querySelector('[data-r="' + k + '"]'); };
    var ASSETS = CFG.assets || {};

    /* ---------- money (Transcy-safe, same approach as cgc-gift-builder.js) ---------- */
    var CUR = CFG.currency || 'USD', DISP = { code: CUR, rate: 1 };
    function fmtFor(code) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }); } catch (e) { return null; } }
    var fmt = fmtFor(CUR);
    function syncDisplay() {
      var code = CUR, rate = 1;
      try {
        var t = window._transcy, v = t && t.variants, info = v && v.currencyActiveInfo;
        var want = v && ((v.currencyTargetInfo && v.currencyTargetInfo.code) || v.currencyCurrent);
        if (want && want !== CUR && info && info.code === CUR && info.detail && info.detail.convert && info.detail.convert[want]) { code = want; rate = +info.detail.convert[want]; }
      } catch (e) {}
      var changed = code !== DISP.code; DISP = { code: code, rate: rate }; fmt = fmtFor(code); return changed;
    }
    function D(c) { return DISP.code === CUR ? c : Math.round(c / 100 * DISP.rate) * 100; }
    function money(dc) {
      var s = fmt ? fmt.format(dc / 100) : '$' + (dc / 100).toFixed(2);
      if (DISP.code === 'CAD') s = s.replace('CA$', 'C$');
      s = s.replace(/\.00$/, '');
      return DISP.code === CUR ? s : s.replace(/([^\d\s])(\d)/, '$1​$2');
    }
    function mD(dc) { return DISP.code === CUR ? '<span class="cgb-money">' + money(dc) + '</span>' : '<tc-money translate="no" class="cgb-money money-done--' + DISP.code + '">' + money(dc) + '</tc-money>'; }
    function m$(c) { return mD(D(c)); }

    /* ---------- model ---------- */
    var CI = P.options.map(function (o) { return o.name.toLowerCase(); }).indexOf(String(CFG.colorOption || 'Color').toLowerCase());
    var COLORS = CI > -1 ? P.options[CI].values : [];
    function vFor(color) { return P.variants.filter(function (v) { return CI < 0 || v.options[CI] === color; })[0]; }
    function okColor(c) { var v = vFor(c); return !!(v && v.available); }
    var firstOk = COLORS.filter(okColor)[0] || COLORS[0];
    var TIERS = (CFG.tiers || []).map(function (t) { return { qty: Math.max(1, +t.qty || 1), label: t.label, pct: +t.pct || 0, badge: t.badge, tag: t.tag, on: !!t.on }; });
    var S = { color: (CFG.defaultColor && COLORS.indexOf(CFG.defaultColor) > -1 && okColor(CFG.defaultColor)) ? CFG.defaultColor : firstOk,
      tier: 0, picks: [], vals: {} };
    TIERS.forEach(function (t, i) { if (t.on) S.tier = i; });
    function tierPicks() { var t = TIERS[S.tier]; while (S.picks.length < t.qty) S.picks.push(S.picks[S.picks.length - 1] || S.color); return S.picks.slice(0, t.qty); }
    function variant() { return CI < 0 ? (P.variants.filter(function (v) { return v.available; })[0] || P.variants[0]) : vFor(S.color); }
    var HIDDEN = {};
    String(CFG.hidden || '').split('|').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) HIDDEN[kv.slice(0, i).trim()] = kv.slice(i + 1).trim(); });

    /* ---------- gallery ---------- */
    var GAL = (CFG.gallery || []).filter(function (g) { return g.src; });
    var mainimg = R('mainimg'), ovl = R('ovl'), cnt = R('count'), thumbs = R('thumbs'), note = R('note'), spotsEl = R('spots');
    var galIdx = 0, inPreview = false;
    function setSpots(on) { inPreview = on; spotsEl.classList.toggle('cgj-on', on); }
    function showGal(i, fromUser) {
      if (!GAL.length) return;
      galIdx = (i + GAL.length) % GAL.length; var g = GAL[galIdx];
      if (mainimg.getAttribute('src') !== g.src) { mainimg.removeAttribute('srcset'); mainimg.src = g.src; }
      mainimg.alt = g.alt || CFG.title; ovl.textContent = ''; cnt.textContent = (galIdx + 1) + ' / ' + GAL.length;
      note.classList.remove('cgb-on'); setSpots(false);
      [].forEach.call(thumbs.children, function (b, j) { b.classList.toggle('cgb-on', j === galIdx); b.setAttribute('aria-current', j === galIdx ? 'true' : 'false'); });
      if (fromUser && g.color && COLORS.indexOf(g.color) > -1 && okColor(g.color) && !TIERS.length) { S.color = g.color; render(); }
    }
    GAL.forEach(function (g, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.innerHTML = '<img src="' + esc(g.th || g.src) + '" alt="" loading="lazy" width="80" height="80">';
      b.onclick = function () { showGal(i, true); }; thumbs.appendChild(b);
    });
    function asset(pat, color) {
      if (!pat) return null;
      var f = String(pat).replace(/\{([^}]+)\}/g, function (m, n) { return n.toLowerCase() === String(CFG.colorOption || 'Color').toLowerCase() ? handle(color || S.color) : m; });
      return ASSETS[f] || null;
    }
    function showUrl(url, chip, preview) {
      if (!url) return;
      if (mainimg.getAttribute('src') !== url) { mainimg.removeAttribute('srcset'); mainimg.src = url; }
      mainimg.alt = CFG.title + (S.color ? ', ' + S.color : '');
      ovl.textContent = ''; cnt.textContent = '';
      note.textContent = chip || ''; note.classList.toggle('cgb-on', !!chip);
      setSpots(!!preview);
      [].forEach.call(thumbs.children, function (b) { b.classList.remove('cgb-on'); b.setAttribute('aria-current', 'false'); });
    }
    showGal(0);
    R('prev').onclick = function () { showGal(galIdx - 1, true); };
    R('nxt').onclick = function () { showGal(galIdx + 1, true); };
    var gx = null, wrap = R('mainwrap');
    wrap.addEventListener('touchstart', function (e) { gx = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) { if (gx === null) return; var d = e.changedTouches[0].clientX - gx; if (Math.abs(d) > 40) showGal(galIdx + (d < 0 ? 1 : -1), true); gx = null; });

    /* engraving preview: typed text drawn over the blank-plate photo (HTML text, never AI lettering) */
    (CFG.spots || []).forEach(function (sp) {
      var el = document.createElement('span'); el.className = 'cgj-spot'; el.dataset.prop = sp.prop;
      el.style.left = sp.x + '%'; el.style.top = sp.y + '%';
      el.style.transform = 'translate(-50%,-50%) rotate(' + (+sp.rot || 0) + 'deg) skewX(' + (+sp.skew || 0) + 'deg)';
      el.style.fontSize = 'calc(' + (+sp.size || 22) / 10 + ' * var(--cgj-w, 6px))';
      el.dataset.ph = sp.ph || ''; spotsEl.appendChild(el);
    });
    function sizeSpots() { spotsEl.style.setProperty('--cgj-w', (wrap.clientWidth / 100) + 'px'); }
    sizeSpots(); window.addEventListener('resize', sizeSpots);
    function drawSpots() {
      [].forEach.call(spotsEl.children, function (el) { var v = (S.vals[el.dataset.prop] || '').trim(); el.textContent = v || el.dataset.ph; el.classList.toggle('cgj-ph', !v); });
    }

    /* ---------- metal swatches (CSS only, like the rose box ttr-swatch: a round metallic dot with a highlight) ---------- */
    function metal(c) {
      var v = String(c).toLowerCase(), g = v.indexOf('gold') > -1, si = v.indexOf('silver') > -1;
      var k = g && si ? 'two' : g ? 'gold' : si ? 'silver' : v.indexOf('rose') > -1 ? 'rose' : '';
      return k ? '<i class="cgj-metal cgj-metal--' + k + '" aria-hidden="true"></i>' : '';
    }
    /* ---------- color picker: pills with a metal swatch (no product photos) ---------- */
    function renderTiles() {
      var box = R('tiles'); if (!box) return; box.innerHTML = '';
      box.className = 'cgj-swatches'; box.setAttribute('role', 'radiogroup');
      COLORS.forEach(function (c) {
        var ok = okColor(c), on = S.color === c, b = document.createElement('button'); b.type = 'button';
        b.className = 'cgj-sw' + (on ? ' cgb-on' : ''); b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', on ? 'true' : 'false');
        if (!ok) { b.disabled = true; b.setAttribute('aria-label', c + ', sold out'); }
        b.innerHTML = metal(c) + '<span>' + esc(String(CFG.colorLabel || '{value}').replace('{value}', c)) + '</span>' + (ok ? '' : '<small>Sold out</small>');
        if (ok) b.onclick = function () { S.color = c; var u = asset(CFG.main, c); if (u) showUrl(u, (CFG.note || '').replace('{Color}', c)); render(); };
        box.appendChild(b);
      });
    }
    /* ---------- tiers (charm kit "how many") ---------- */
    function tierPrice(t) { var v = variant(); var base = v.price * t.qty; return { now: Math.round(base * (100 - t.pct) / 100), was: Math.max(v.compare_at_price || 0, v.price) * t.qty }; }
    function renderTiers() {
      var box = R('tiers'); if (!box) return; box.innerHTML = '';
      TIERS.forEach(function (t, i) {
        var on = S.tier === i, pr = tierPrice(t), w = document.createElement('div');
        w.className = 'cgj-tier' + (on ? ' cgb-on' : '');
        var head = '<button type="button" class="cgj-tier__btn" role="radio" aria-checked="' + on + '"><span class="cgj-radio" aria-hidden="true"></span>' +
          '<span class="cgj-tier__lbl">' + esc(t.label) + (t.tag ? ' <span class="cgj-tag">' + esc(t.tag) + '</span>' : '') + '</span>' +
          '<span class="cgj-tier__pr">' + m$(pr.now) + (pr.was > pr.now ? '<s>' + m$(pr.was) + '</s>' : '') + '</span></button>' +
          (t.badge ? '<span class="cgj-badge">' + esc(t.badge) + '</span>' : '');
        w.innerHTML = head;
        w.querySelector('button').onclick = function () { S.tier = i; render(); };
        if (on && COLORS.length > 1) {
          var picks = tierPicks(), g = document.createElement('div'); g.className = 'cgj-picks';
          picks.forEach(function (pc, k) {
            var row = document.createElement('div'); row.className = 'cgj-pick';
            row.innerHTML = '<span>' + esc(String(CFG.tierPickLabel || 'Kit {n}').replace('{n}', k + 1)) + '</span>';
            COLORS.forEach(function (c) {
              var ok = okColor(c), b = document.createElement('button'); b.type = 'button';
              b.className = 'cgj-chip' + (pc === c ? ' cgb-on' : ''); b.setAttribute('aria-pressed', pc === c ? 'true' : 'false');
              b.innerHTML = metal(c) + esc(c);
              if (!ok) b.disabled = true; else b.onclick = function () { S.picks[k] = c; S.color = c; var u = asset(CFG.main, c); if (u) showUrl(u, ''); render(); };
              row.appendChild(b);
            });
            g.appendChild(row);
          });
          w.appendChild(g);
        }
        box.appendChild(w);
      });
    }

    /* ---------- fields ---------- */
    var FIELDS = [].slice.call(root.querySelectorAll('.cgj-field input'));
    FIELDS.forEach(function (inp) {
      inp.addEventListener('input', function () {
        S.vals[inp.dataset.prop] = inp.value; inp.closest('.cgj-field').querySelector('[data-count]').textContent = inp.value.length + '/' + inp.maxLength;
        inp.closest('.cgj-field').classList.remove('cgj-bad');
        if (CFG.spots && CFG.spots.length) { var u = asset(CFG.preview); if (u && !inPreview) showUrl(u, '', true); drawSpots(); }
        R('err').hidden = true;
      });
      inp.addEventListener('focus', function () { if (CFG.spots && CFG.spots.length) { var u = asset(CFG.preview); if (u) { showUrl(u, '', true); drawSpots(); } } });
    });

    /* ---------- extras ---------- */
    var X = R('xbox') && window.CGCExtras && CFG.extras && CFG.extras.length ? window.CGCExtras.mount(R('xbox'), CFG.extras, { money: function (c) { return m$(c); }, section: CFG.section, onchange: function () { render(); } }) : null;
    var XKEY = '_jewelry_bundle_id';
    function xSum() { var t = 0, w = 0; if (X) X.lines().forEach(function (l) { t += l.p; w += Math.max(l.w || 0, l.p); }); return { now: t, was: w }; }

    /* ---------- price + total ---------- */
    function totals() {
      var v = variant();
      if (TIERS.length) { var t = TIERS[S.tier], pr = tierPrice(t); return { now: pr.now, was: pr.was, label: CFG.title + ' · ' + t.label }; }
      return { now: v.price, was: Math.max(v.compare_at_price || 0, v.price), label: CFG.title + (COLORS.length > 1 ? ' · ' + S.color : '') };
    }
    /* title block price row = the current picks, same as the total (a preselected "how many" tier counts); no Save % tag */
    function renderTitlePrice() {
      var v = variant(), tb = R('tbprice'); if (!tb || !v) return;
      var T = totals();
      tb.innerHTML = '<span class="cgc-tb__now">' + m$(T.now) + '</span>' + (T.was > T.now ? '<s class="cgc-tb__was">' + m$(T.was) + '</s>' : '');
    }
    var busy = false;
    function render() {
      renderTiles(); renderTiers(); renderTitlePrice();
      var T = totals(), xs = xSum(), tot = D(T.now) + D(xs.now), save = D(T.was) + D(xs.was) - tot;
      var lines = '<div class="cgb-tl"><span>' + esc(T.label) + '</span><span class="cgb-p">' + m$(T.now) + (T.was > T.now ? '<s>' + m$(T.was) + '</s>' : '') + '</span></div>';
      if (TIERS.length && COLORS.length > 1) {
        var cnt2 = {}; tierPicks().forEach(function (c) { cnt2[c] = (cnt2[c] || 0) + 1; });
        lines += '<div class="cgb-tl cgb-subl"><span>' + Object.keys(cnt2).map(function (c) { return cnt2[c] + ' × ' + c; }).join(', ') + '</span></div>';
      }
      if (X) lines += X.lines().map(function (l) { return '<div class="cgb-tl"><span>' + esc(l.t) + '</span><span class="cgb-p">' + m$(l.p) + (l.w > l.p ? '<s>' + m$(l.w) + '</s>' : '') + '</span></div>'; }).join('');
      R('lines').innerHTML = lines;
      R('tot').innerHTML = mD(tot);
      R('save').innerHTML = save > 0 ? 'You save ' + mD(save) : '';
      var n = +CFG.installments || 0, lt = R('instlogo'), logo = lt ? lt.innerHTML.trim() : '';
      R('inst').innerHTML = n > 1 ? esc(CFG.installmentsText || 'or {n} payments of {amount}').replace('{n}', n).replace('{amount}', mD(Math.round(tot / n))).replace('{logo}', logo) : '';
      if (!busy) R('atc').innerHTML = esc(CFG.atcLabel || 'Add to cart') + ' · ' + mD(tot);
      R('stickyTxt').innerHTML = esc(CFG.atcLabel || 'Add to cart') + ' · ' + mD(tot);
      drawSpots(); stickyTops();
    }
    if (R('rating')) R('rating').onclick = function () { var t = CFG.reviewsTarget && document.querySelector(CFG.reviewsTarget); if (t) t.scrollIntoView({ behavior: 'smooth' }); };

    /* ---------- add to cart ---------- */
    function props() {
      var o = {}; Object.keys(HIDDEN).forEach(function (k) { o[k] = HIDDEN[k]; });
      FIELDS.forEach(function (inp) { var v = inp.value.trim(); if (v) o[inp.dataset.prop] = v; });
      return o;
    }
    function payload() {
      var pr = props(), has = Object.keys(pr).length > 0;
      if (TIERS.length) {
        var byColor = {}, order = [];
        tierPicks().forEach(function (c) { if (!byColor[c]) { byColor[c] = 0; order.push(c); } byColor[c]++; });
        return { items: order.map(function (c) { var it = { id: (CI < 0 ? variant() : vFor(c)).id, quantity: byColor[c] }; if (has) it.properties = pr; return it; }) };
      }
      var it = { id: variant().id, quantity: 1 }; if (has) it.properties = pr;
      return { items: [it] };
    }
    /* picked extras join the call: one shared bundle id on every line (the gift's lines first) */
    function withExtras(body) {
      if (!X || !X.any()) return body;
      var bid = 'JW-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase(), xp = {}; xp[XKEY] = bid;
      body.items.forEach(function (it) { it.properties = it.properties || {}; it.properties[XKEY] = bid; });
      body.items = body.items.concat(X.items(xp));
      return body;
    }
    function missing() { return FIELDS.filter(function (inp) { return inp.required && !inp.value.trim(); }); }
    function openDrawer() {
      try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} })); } catch (e) {}
      if (window.CGCCart) { try { if (window.CGCCart.open() !== false) return; } catch (e) {} }   /* the cart drawer (assets/cgc-drawer.js) */
      var icon = document.querySelector('.site-header .js-drawer-open-cart, a.js-drawer-open-cart, .site-header a[href$="/cart"]');
      if (icon) { icon.click(); return; } window.location.href = CFG.cartUrl;
    }
    var api = REG[CFG.section] = { S: S, render: render, payload: payload, last: null, showGal: showGal, extras: X };
    function addToCart() {
      if (busy) return;
      var atc = R('atc'), err = R('err'), miss = missing();
      if (miss.length) {
        miss.forEach(function (i) { i.closest('.cgj-field').classList.add('cgj-bad'); });
        err.textContent = 'Please fill in every engraving line first.'; err.hidden = false;
        miss[0].focus({ preventScroll: true }); miss[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
      }
      var body = withExtras(payload()); api.last = body;
      busy = true; atc.setAttribute('aria-busy', 'true'); atc.textContent = 'Adding…'; err.hidden = true;
      fetch(CFG.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () { busy = false; atc.removeAttribute('aria-busy'); render(); atc.textContent = 'Added ✓'; setTimeout(render, 2500); openDrawer(); })
        .catch(function (e) { busy = false; atc.removeAttribute('aria-busy'); render(); err.textContent = e.message; err.hidden = false; });
    }
    R('atc').onclick = addToCart;

    /* ---------- delivery ---------- */
    var ship = addBiz(new Date(), +CFG.dispatchDays || 1), a1 = addBiz(ship, +CFG.minDays || 1), z1 = addBiz(ship, +CFG.maxDays || 5);
    var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    if (R('del1')) R('del1').textContent = f(a1) + ' – ' + f(z1);
    R('del2').textContent = String(CFG.deliveryLine || '').replace('{from}', f(a1)).replace('{to}', f(z1));

    /* ---------- sticky mobile CTA + sticky desktop columns ---------- */
    var cardVisible = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { cardVisible = e.isIntersecting; }); syncSticky(); }).observe(R('builder'));
    function syncSticky() { R('sticky').classList.toggle('cgb-hide', cardVisible || window.scrollY < 300); }
    window.addEventListener('scroll', syncSticky, { passive: true });
    R('sticky').onclick = function () { R('builder').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    function stickyTops() {
      ['media', 'buy'].forEach(function (k) {
        var el = R(k); if (!el) return;
        if (window.innerWidth < 990) { el.style.top = ''; return; }
        var h = el.offsetHeight, vh = window.innerHeight; el.style.top = (h + 48 > vh ? Math.min(24, vh - h - 24) : 24) + 'px';
      });
    }
    window.addEventListener('resize', function () { stickyTops(); sizeSpots(); });
    if (window.ResizeObserver) { var ro = new ResizeObserver(function () { stickyTops(); sizeSpots(); }); ro.observe(R('buy')); ro.observe(R('media')); }

    syncDisplay(); render();
    var tcTries = 0, tcT = setInterval(function () { if (syncDisplay()) render(); if (++tcTries > 50) clearInterval(tcT); }, 400);
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-cgj]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
